import { Link } from "react-router-dom";

function Navbar() {
  return (
    <nav className="navbar has-background-white is-fixed-top">
      <div className="navbar-brand">
        <div className="logo-wrapper">
          <img
            src="/CVDD.Logo.jpg"
            alt="Logo Comunidad Cristiana"
            className="navbar-logo"
          />
        </div>
        <div className="logo-wrapper">
          <h1 className="navbar-title">
            <span className="navbar-title-part">Comunidad</span>
            <span className="navbar-title-part">Victoria de Dios</span>
          </h1>
        </div>
      </div>

      <div className="navbar-menu">
        {/* Menú de navegación */}
        <div className="navbar-end">
          <ul className="navbar-item">
            <li>
              <Link to="/" className="navbar-item">
                Inicio
              </Link>
            </li>
            <li>
              <span className="navbar-item">Quiénes Somos</span>
            </li>
            <li>
              <span className="navbar-item">Eventos</span>
            </li>
            <li>
              <span className="navbar-item">Recursos</span>
            </li>
            <li>
              <span className="navbar-item">Contacto</span>
            </li>
            <li>
              <span className="navbar-item">Ingreso</span>
            </li>
          </ul>
        </div>
      </div>

      {/* Logo al final (derecha), logo más pequeño y alargado */}
      <div className="navbar-menu">
        <div className="navbar-end">
          <div className="logo-container">
            <a
              href="https://espadadelespiritu.net/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src="/EspadaEspiritu.png"
                alt="Logo Derecho"
                className="logo-right"
              />
            </a>
          </div>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
